import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import Baggage from './../models/Baggage';

const initialState = {
    isFetching: false,
    isFetched: false,
    baggages: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    loadingGroup: false,
    detail: {
        baggage: new Baggage()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.BAGGAGE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.BAGGAGE_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                baggages: action.baggages.result,
                pageSize: action.baggages.pageSize,
                pageIndex: action.baggages.pageIndex,
                totalCount: action.baggages.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.BAGGAGE_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, baggageS: [] };
        case Types.BAGGAGE_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.BAGGAGE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    baggage: action.baggage
                }
            };
        case Types.BAGGAGE_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.SITEINFO_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.SITEINFO_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.BAGGAGE_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        default: return state
    }
}